export default payload => {
	return {
		type: 'UPDATE_PRODUCT_CATEGORIES',
		payload
	}
}
